import React, { useMemo } from 'react';
import styled from 'styled-components';
import { type SceneData, SceneType, type TabMain } from '@types';
import ImgPano from './img-pano.png';
import ImgPanoM from './img-pano-m.png';
import ImgPVideo from './img-pvideo.png';
import ImgPVideoM from './img-pvideo-m.png';
import ImgMatrix from './img-matrix.png';
import ImgMatrixM from './img-matrix-m.png';

interface Props {
  type: SceneType;
  tab?: TabMain;
  data?: SceneData;
}

const Icon = styled.img.attrs({
  draggable: 'false',
})`
  position: absolute;
  top: 4px;
  left: 4px;
  width: 26px;
  height: 16px;
`;

const IconM = styled(Icon)`
  width: 38px;
`;

function TypeMark({ type, tab, data }: Props) {
  const isMarked = useMemo(() => {
    if (!tab || !data) return false;
    if (tab === 'hotspot') {
      return !!(data.hotspot?.length ?? 0);
    }
    if (tab === 'music') {
      return !!data.sound?.mediaUrl;
    }
    if (tab === 'mask') {
      return !!data.mask?.top?.mediaUrl || !!data.mask?.bottom?.mediaUrl;
    }
    if (tab === 'sandTable') {
      return !!data.sandBox?.list?.length;
    }
    if (tab === 'effect') {
      return !!data.effect?.length;
    }
  }, [tab, data]);

  if (type === SceneType.pano)
    return isMarked ? <IconM src={ImgPanoM} /> : <Icon src={ImgPano} />;
  if (type === SceneType.panoVideo)
    return isMarked ? <IconM src={ImgPVideoM} /> : <Icon src={ImgPVideo} />;
  if (type === SceneType.matrix)
    return isMarked ? <IconM src={ImgMatrixM} /> : <Icon src={ImgMatrix} />;
  return null;
}

export default TypeMark;
